// extracted by mini-css-extract-plugin
module.exports = {"legend":"ToggableChartLegend_legend__36Wop"};